/**
 * @generated SignedSource<<fb6dfcae69c00de45066cc1e692f7f8b>>
 * @relayHash d47801fcc320403d37d78682b2201daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d5679c2a92b4d468616bad4dd656294352cc470b1c08efa6484834134a8a050

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogMetaAPIConsumerWrapperQuery } from './BacklogMetaAPIConsumerWrapperQuery.graphql';

const node: PreloadableConcreteRequest<BacklogMetaAPIConsumerWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4d5679c2a92b4d468616bad4dd656294352cc470b1c08efa6484834134a8a050",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward"
        }
      ]
    },
    "name": "BacklogMetaAPIConsumerWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
